export default __webpack_public_path__ + "images/destinations/mattermost.png";